export const BADGE_COUNT = 5;
